import React, { FC } from 'react';
import { AddInput } from '../../../../../lib/components/AddInput';
import { ListFooter } from '../../../../../lib/components/List/ListFooter';
import { usePartnerConfigForm } from '../../hooks/usePartnerConfigForm';

interface IProps {
	on_added: (d: string) => void;
}

export const AddDomainInput: FC<IProps> = ({ on_added }) => {
	const { validators } = usePartnerConfigForm();

	return (
		<ListFooter>
			<AddInput
				{...{
					on_added,
					validate: validators.domain,
				}}
			/>
		</ListFooter>
	);
};
